import {
	Alert,
	Box,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	MenuItem,
	Paper,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { useContext } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { getTiposDocumentos } from "../../../project/services/TipoDocumentoService";
import { modifyDocumento } from "../../../project/services/ClienteService";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialDocumentoCorrecto = {
	tipoDocumento: "",
	numeroDocumento: "",
};
//
// ################################################################################
//
const CambiarDocumentoDialog = ({
	open,
	onClose,
	idCliente,
	tipoDocumentoActual,
	numeroDocumentoActual,
}) => {
	const [documentoCorrecto, setDocumentoCorrecto] = useState(
		initialDocumentoCorrecto
	);
	const [clientes, setClientes] = useState([]);
	const [showClientes, setShowClientes] = useState(false);
	const [showCambioDocumentoSuccess, setShowCambioDocumentoSuccess] =
		useState(false);
	const [isDoingSomething, setIsDoingSomething] = useState(false);
	const [tipoDocumentoActualDescripcion, setTipoDocumentoActualDescripcion] =
		useState("");
	const { cliente, setCliente } = useContext(GestionAtencionContext);
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);
	const [tiposDocumentos, setTiposDocumentos] = useState([]);
	//
	// ################################################################################
	//
	useEffect(() => {
		loadTiposDocumentos();
	}, []);
	//
	// ################################################################################
	//
	const loadTiposDocumentos = async () => {
		const response = await getTiposDocumentos();
		if (response.ok) {
			setTiposDocumentos(response.data.data);
		} else {
			setTiposDocumentos([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	useEffect(() => {
		setDocumentoCorrecto(initialDocumentoCorrecto);
		setClientes([]);
		setShowClientes(false);
		setShowCambioDocumentoSuccess(false);
		if (tiposDocumentos.length > 0) {
			setTipoDocumentoActualDescripcion(
				tiposDocumentos.find((item) => item.id === tipoDocumentoActual)
					.descripcion
			);
		}
	}, [open, tipoDocumentoActual, tiposDocumentos]);
	//
	// ################################################################################
	//
	const handleChange = (e) => {
		setDocumentoCorrecto({
			...documentoCorrecto,
			[e.target.name]: e.target.value,
		});
	};
	//
	// ################################################################################
	//
	const handleCambiarDocumento = () => {
		setShowClientes(false);
		setShowCambioDocumentoSuccess(false);

		if (
			documentoCorrecto.tipoDocumento === "" ||
			documentoCorrecto.numeroDocumento === "" ||
			documentoCorrecto.numeroDocumento.length < 7
		) {
			setMessage({
				severity: "info",
				messageText: "El tipo o el número de documento son incorrectos",
			});
			setShowMessage(true);
			return;
		}

		const modificaDocumento = async () => {
			let _params = {
				id_cliente: idCliente,
				id_tipo_documento_nuevo: documentoCorrecto.tipoDocumento,
				num_doc_nuevo: documentoCorrecto.numeroDocumento,
			};

			setIsDoingSomething(true);
			const response = await modifyDocumento(_params);
			setIsDoingSomething(false);

			if (response.ok) {
				if (response.data.data) {
					setClientes(response.data.data);
					setShowClientes(true);
				} else {
					setShowCambioDocumentoSuccess(true);
					setMessage({
						severity: "info",
						messageText: "Se cambió el número de documento del Cliente!",
					});
					setShowMessage(true);

					setCliente({
						...cliente,
						tipoDocumento: documentoCorrecto.tipoDocumento,
						numeroDocumento: documentoCorrecto.numeroDocumento,
					});
				}
			} else {
				setMessage({
					messageText: response.messageText,
					severity: response.messageSeverity,
				});
				setShowMessage(true);
			}
		};

		modificaDocumento();
	};
	//
	// ################################################################################
	//
	const handleCloseDialog = () => {
		onClose();
	};
	//
	// ################################################################################
	//
	return (
		<>
			<Dialog
				open={open}
				onClose={handleCloseDialog}
				fullWidth={true}
				maxWidth="sm"
				scroll="paper"
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Cambiar documento de Cliente
					<IconButton
						aria-label="close"
						onClick={onClose}
						sx={{
							position: "absolute",
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				<DialogContent dividers>
					<Box sx={{ m: 1 }}>
						<Typography variant="h6">
							Tipo y número de documento actual
						</Typography>

						<Box sx={{ m: 2 }}>
							<Grid container spacing={1}>
								<Grid item xs={12} md={6}>
									<TextField
										sx={{ width: "100%" }}
										variant="outlined"
										size="small"
										name="tipoDocumentoActual"
										label="Tipo de documento"
										value={tipoDocumentoActualDescripcion}
										disabled={true}
									/>
								</Grid>
								<Grid item xs={12} md={6}>
									<TextField
										sx={{ width: "100%" }}
										variant="outlined"
										size="small"
										name="numeroDocumentoActual"
										label="Número de documento"
										value={numeroDocumentoActual}
										disabled={true}
									/>
								</Grid>
							</Grid>
						</Box>
					</Box>

					<Box sx={{ m: 1 }}>
						<Typography variant="h6" gutterBottom>
							Tipo y número de documento nuevo
						</Typography>
						<Box sx={{ m: 2 }}>
							<Grid container spacing={1}>
								<Grid item xs={12} md={6}>
									<FormControl fullWidth sx={{ width: "100%" }}>
										<InputLabel id="tipo-documento-select-label">
											Tipo de Documento
										</InputLabel>
										<Select
											labelId="tipo-documento-select-label"
											id="tipo-documento-select"
											name="tipoDocumento"
											value={documentoCorrecto.tipoDocumento}
											label="Tipo de documento"
											size="small"
											onChange={handleChange}
											disabled={
												isDoingSomething ||
												(!isDoingSomething && showCambioDocumentoSuccess)
											}
										>
											{tiposDocumentos.map((item) => (
												<MenuItem key={item.id} value={item.id}>
													{item.descripcion}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
								<Grid item xs={12} md={6}>
									<TextField
										sx={{ width: "100%" }}
										inputProps={{
											autoComplete: "off",
										}}
										variant="outlined"
										size="small"
										name="numeroDocumento"
										label="Número"
										value={documentoCorrecto.numeroDocumento}
										onChange={handleChange}
										disabled={
											isDoingSomething ||
											(!isDoingSomething && showCambioDocumentoSuccess)
										}
									/>
								</Grid>
							</Grid>
						</Box>
					</Box>

					<Box sx={{ mb: 2, textAlign: "right" }}>
						<Button
							sx={{ mr: 1 }}
							variant="contained"
							onClick={handleCambiarDocumento}
							disabled={
								isDoingSomething ||
								(!isDoingSomething && showCambioDocumentoSuccess)
							}
							startIcon={<SyncAltIcon />}
						>
							Cambiar documento
						</Button>
					</Box>

					{showClientes && <ListaClientes clientes={clientes} />}
				</DialogContent>
			</Dialog>

			{/* >>>> Messages */}

			{showMessage && (
				<Message
					showMessage={showMessage}
					setShowMessage={setShowMessage}
					message={message}
				/>
			)}

			<WaitingDialog open={isDoingSomething} />
		</>
	);
};
//
// ################################################################################
//
const ListaClientes = ({ clientes }) => {
	return (
		<Paper elevation={3} sx={{ m: 1, p: 1 }}>
			<Alert severity="warning">
				Ya existe un Cliente con el tipo y número de documento dado. No es
				posible hacer el cambio de documento!
			</Alert>
			<List dense={true}>
				{clientes.map((item) => (
					<ListItem button key={item.id}>
						<ListItemButton>
							<PersonIcon />
							<ListItemText
								inset={true}
								primary={(item.nombre + " " + item.apellido).toUpperCase()}
								secondary={`${item.tipo_documento_descripcion_corta} - ${item.num_doc}`}
							/>
						</ListItemButton>
					</ListItem>
				))}
			</List>
		</Paper>
	);
};

export default CambiarDocumentoDialog;
